import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import Link from 'next/link';
import React, { FC } from 'react';
import { WhatsNew } from '../../pages/learn/whats-new';
import styles from './WhatsNewCard.module.css';
dayjs.extend(advancedFormat);

interface Props {
  whatsNew: WhatsNew;
}

const WhatsNewCard: FC<Props> = ({ whatsNew }) => {
  const getDate = () => {
    const date = new Date(whatsNew.createdAt);
    return dayjs(date).format('MMMM D, YYYY');
  };

  return (
    <Link href={`/learn/whats-new/${whatsNew.slug}`}>
      <a>
        <div className={styles['wrapper']}>
          <div className='body-paragraph text-gray-50'>{getDate()}</div>
          <h2 className='mt-1'>{whatsNew.title}</h2>
          <div className='mt-1 body-paragraph'>{whatsNew.excerpt}</div>
          <div className={`${styles['read-more']} body-paragraph`}>Read More</div>
        </div>
      </a>
    </Link>
  );
};

export default WhatsNewCard;
